export enum DateFormat {
  DAY_MONTH_YEAR_WITH_HOURS_MINS_SECS = 'dd MMM yyyy, HH:mm:ss',
  DAY_MONTH_YEAR_WITH_HOURS_MINS = 'dd MMM yyyy, HH:mm',
  MONTH_DAY_COMMA_YEAR_WITH_HOURS_MINS_SECS = 'MMM dd, yyyy HH:mm:ss',
  MONTH_DAY_COMMA_YEAR_WITH_HOURS_MINS_AMPM = 'MMM dd, yyyy HH:mm a',
  MONTH_DAY_COMMA_YEAR_WITH_HOURS_MINS = 'MMM dd, yyyy HH:mm',
  DAY_MONTH_COMMA_YEAR_WITH_HOURS_MINS_SECS = 'dd MMM, yyyy HH:mm:ss',
  FULL_DATE_NORMAL = 'dd MMMM yyyy',
  DAY_SHORT_MONTH_SHORT_YEAR = 'dd-MMM-yy',
  FULL_MONTH_NAME_DAY_COMMA_YEAR = 'MMMM dd, yyyy',
  YEAR_MONTH_DAY_NUMERIC = 'yyyy-MM-dd',
  YEAR_MONTH_DAY_NUMERIC_WITH_HOURS_MINS = 'yyyy-MM-dd HH:mm',
  YEAR_MONTH_DAY_NUMERIC_WITH_HOURS_MINS_SECS = 'yyyy-MM-dd HH:mm:ss',
  TIMESTAMP = "yyyy-MM-dd'T'HH:mm:ss",
  SHORT_MONTH_AND_DAY = 'MMM dd',
  SHORT_MONTH_DAY_WITH_HOURS_MINS = 'MMM dd, HH:mm',
  FULL_MONTH_NAME = 'MMMM',
  HOURS_MINS = 'HH:mm',
  YEAR_SHORT_MONTH = 'yyyy-MMM',
}
